
export class ConnectorId {
    id: String;
    user_id: Number;
    name: String;
    current: Boolean;

    constructor(
      user_id: Number,
      name: String,
      current: Boolean
    ) { 
        this.user_id = user_id
        this.name = name
        this.current = current
    }

    clone(){
        return new ConnectorId(this.user_id,this.name,this.current)
    }
}